export default "__VITE_ASSET__CmbvpwkF__"